export const HISTORY_PLACE_DETAILS_FETCHED = 'HISTORY_PLACE_DETAILS_FETCHED';
export const HISTORY_PLACE_DETAILS_UPDATE = 'HISTORY_PLACE_DETAILS_UPDATE';
